/**
 * このファイルはコンポーネントのディレクトリとして使われます
 * 目的は外部へ提供するコンポーネントを一元管理し、分類しやすくすることです
 */
/**
 * レイアウトコンポーネント
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export { AvatarDropdown, AvatarName, Footer, Question, SelectLang };
